import { useState } from 'react';
import { Chip, Box } from '@mui/material';

const names = [
  'FootFall',
  'Interaction',
  'Staff Availability',
  'Journey',
  'Light Timing',
  'Departmental Conversion',
  'Customer-Product Engagement',
  'Queue Count',
];

export default function SelectableChips({ graphToSelect }) {
  const [selected, setSelected] = useState('FootFall');

  const handleSelect = (name) => {
    if (name === 'Engagement') return; // Disable selection for 'Engagement'
    setSelected(name);
    graphToSelect(name);
  };

  return (
    <Box
      className="scrollbar"
      sx={{
        display: 'flex',
        gap: 1,
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        p: 1,
        width: '100%'
      }}
    >
      {names.map((name) => (
        <Chip
          key={name}
          label={name}
          onClick={() => handleSelect(name)}
          sx={{
            borderRadius: '20px',
            px: 1.5,
            marginTop: '2px',
            backgroundColor: selected === name ? '#44BE54' : '#f0f0f0',
            color: selected === name ? '#fff' : '#000',
            opacity: name === 'Engagement' ? 0.6 : 1,
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': {
              backgroundColor: selected === name ? '#329242' : '#e0e0e0'
            }
          }}
        />
      ))}
    </Box>
  );
}
